import React from "react";
import { Router } from "@reach/router";
import { csrfHeaderName, index } from "./utils/constants";

//page content component
import PlanSelection from "./components/planSelection/planSelection";
import RegisterPanel from "./components/signupForm/Register/RegisterPanel";
import BillingPanel from "./components/signupForm/Billing/BillingPanel";
import EmailVerification from "./components/signupForm/emailVerification/emailVerification";

//context
import { AppContextProvider } from "./context/AppContext";
import { PlansContextProvider } from "./context/PlansContext";
import { SignupContextProvider } from "./context/SignupContext";
import { ConfigContextProvider } from "./context/ConfigContext";
import { message } from "antd";
import { withCookies } from "react-cookie";

import axios from "axios";
import NotFound from "./components/notFound/NotFound";

const App = props => {
    message.config({
        top: 80,
        duration: 4,
    });
    const { cookies } = props;
    axios.defaults.headers.post[csrfHeaderName] = cookies.get(csrfHeaderName);

    return (
        <ConfigContextProvider>
            <AppContextProvider>
                <PlansContextProvider>
                    <SignupContextProvider>
                        <Router primary={false} basepath={index}>
                            <PlanSelection path="/" />
                            <RegisterPanel path="signup" />
                            <BillingPanel path="billing" />
                            <EmailVerification path="activation" />
                            <NotFound default />
                        </Router>
                    </SignupContextProvider>
                </PlansContextProvider>
            </AppContextProvider>
        </ConfigContextProvider>
    );
};

export default withCookies(App);
